import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { formattingDigitCurrency } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(171, 171, 171, 0.1)',
    height: '55px',
    margin: '.3rem 0 1rem 0',
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h6': {
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 700,
    },
  },
  label: {
    margin: '0 1rem',
  },
  bold: {
    fontWeight: 700,
  },
}));

const Total = ({ totals, currency, styles, label }) => {
  const classes = useStyles();

  const { countryCode, labelCode } = currency || {};
  const { bold } = styles || {};
  const { amount } = totals || {};
  const formattingAmount = formattingDigitCurrency(
    amount,
    countryCode,
    labelCode,
  );
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.total}>
        <Typography
          display="inline"
          variant="h6"
          data-testid="label"
          className={`${classes.label} ${bold ? classes.bold : ''}`}
        >
          {label}
        </Typography>
        <Typography
          display="inline"
          variant="h6"
          className={`${classes.label} ${bold ? classes.bold : ''}`}
          data-testid="amount"
        >
          {formattingAmount}
        </Typography>
      </Grid>
    </Grid>
  );
};

Total.propTypes = {
  totals: PropTypes.shape({
    amount: PropTypes.number,
  }).isRequired,
  currency: PropTypes.shape({
    countryCode: PropTypes.string,
    labelCode: PropTypes.string,
    symbol: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
  styles: PropTypes.object,
};

Total.defaultProps = {
  totals: {
    amount: 0,
  },
  currency: {
    countryCode: 'fr-FR',
    labelCode: 'EUR',
    symbol: '€',
  },
  label: 'totalToPay',
  styles: {
    bold: false,
  },
};
export default Total;
